var prefix = 'pm-alt-text';
export var ClassNames = {
  FLOATING_TOOLBAR_COMPONENT: "".concat(prefix, "-alt-text-floating-toolbar"),
  MEDIA_CONTAINER: 'mediaView-content-wrap'
};